export const eventIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M17 2h-1V0h-2v2H6V0H4v2H3a1.99 1.99 0 0 0-1.99 2L1 18a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 16H3V8h14zm0-12H3V4h14zm-7 5h5v5h-5z"/></svg>`,
  name: 'event',
};
